<template>
  <div>
    <el-table
      :data="tableData"
      border
      size="mini"
      style="width: 100%"
      :close-on-click-modal="false"
    >
      <el-table-column type="index" width="100" label="序号"></el-table-column>
      <el-table-column
        prop="approveTypeShow"
        label="审批流类型"
        width="120px"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        prop="applyDeptName"
        label="项目部"
        width="120px"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        prop="projectName"
        label="项目名称"
        width="120px"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        prop="itemName"
        label="审批内容"
        class-name="itemNameClass"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        prop="submitUserName"
        label="提交人"
        width="120px"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="提交时间"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        prop="submitUserDeptName"
        label="提交人部门"
        width="120px"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        prop="statusShow"
        label="审批状态"
        width="120px"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="handleClick(scope.row)"
            >前往处理
          </el-button>
          <!-- <el-button
						type="text"
						size="mini"
						@click="handleClick(scope.row, leftActionBtn)"
						v-if="
							(scope.row.isBackAllowed &&
								leftActionBtn == '取消审批') ||
								leftActionBtn == '审批'
						"
						>{{ leftActionBtn }}
					</el-button> -->
          <!-- <el-button type="text" size="mini" @click="handleDelete(scope.row)"
            >删除
          </el-button>
          <el-button
            type="text"
            size="mini"
            @click="handleClick(scope.row, rightActionBtn)"
            >{{ rightActionBtn }}
          </el-button> -->
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {
  deleteOneAllContractSevice, //删除一条总包合同数据
	deleteOneProjectSevice, //删除一条项目立项单数据
	deleteOneSubServiceContractSevice, //删除一条劳务合同数据
} from "@/services/allContractServices";
import {
  deleteDeclaration, //删除会议提报单
} from "@/services/declarationServices";
export default {
  name: "table",
  props: {
    tableData: {
      type: Array,
    },
    leftActionBtn: {
      type: String,
    },
    rightActionBtn: {
      type: String,
    },
  },
  methods: {
    handleClick(row, btnName) {
      this.$emit("actionBtnClick", {
        row,
        btnName,
      });
    },
    handleDelete(row) {
      this.$confirm("确认删除该条数据吗?", "提示", {
        confirmButtonText: "确认",
      }).then(() => {
        let fun = this.deleteItem(row);
				let param={delIds:row.itemId}
				fun(param).then(res=>{
					if (res.code == 10000000) {
              this.$message.success("删除成功");
              this.$emit('handleQuery');
            } else if (res.code >= 20000000) {
              this.$message.warning(res.msg);
            } else {
              this.$message.error("系统异常");
            }

				})
      });
    },
    deleteItem(row) {
      let type = row.type;
      let funMethod;
      switch (type) {
        case "SUPPLIER": //供应商
          funMethod = '';
          break;
        case "PROJECT_FRONT": //事前成本
          funMethod = deleteOneAllContractSevice();
          break;
        case "PROJECT_MIDDLE": //事中成本
          funMethod = deleteOneAllContractSevice();
          break;
        case "GENERAL_CONTRACT": //总包合同
          funMethod = deleteOneAllContractSevice();
          break;
        case "PROJECT": //项目
          funMethod = deleteOneProjectSevice();
          break;
        case "SUB_CONTRACT": //分项合同
          funMethod = deleteOneSubServiceContractSevice();
          break;
        case "DECLARATION": //会议提报
          funMethod = deleteDeclaration();
          break;
        case "INPUT_BILL_APPROVE": //进项发票报销审批 ====
          funMethod = deleteOneAllContractSevice();
          break;
        case "OUTPUT_BILL_APPROVE": //销项发票报销审批 ====
          funMethod = deleteOneAllContractSevice();
          break;
        case "EARNING_COST": //收入成本
          funMethod = deleteOneAllContractSevice();
          break;
        case "OFFICIAL_DOCUMENT_SEND": //公文-发文
          funMethod = deleteOneAllContractSevice();
          break;
        case "OFFICIAL_DOCUMENT_RECEIVE": //公文-收文
          funMethod = deleteOneAllContractSevice();
          break;
      }
      return funMethod;
    },
  },
};
</script>

<style scoped lang="scss">
/deep/ td.itemNameClass .cell {
  color: red;
}
</style>
